import vue from 'vue'
const state = {
    toEdit: null,
};

const mutations = {
    SET_MODEL_EDIT(state, model) {
        state.toEdit = model;
    },
    REMOVE_MODEL_EDIT(state) {
        state.toEdit = null;
    }
};

const actions = {
    setModel(context, model) {
        context.commit('SET_MODEL_EDIT', model)
    },

    setAnalise(context, idAnalise) {
        vue.http.get(`api/analises/${idAnalise}`).then((response) => context.commit('SET_MODEL_EDIT', response.data)).catch(error => {
            throw Error(error)
        })

    },

    removeEditingModel (context) {
        context.commit('REMOVE_MODEL_EDIT')
    }
};

export default {
    state,
    mutations,
    actions
}
